/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { EncounterStayType } from './EncounterStayType';
import {
    EncounterStayTypeFromJSON,
    EncounterStayTypeFromJSONTyped,
    EncounterStayTypeToJSON,
    EncounterStayTypeToJSONTyped,
} from './EncounterStayType';

/**
 * 
 * @export
 * @interface CreateInProgressEncounterRequest
 */
export interface CreateInProgressEncounterRequest {
    /**
     * 
     */
    lead_id: string;
    /**
     * Adds the encounter to this ongoing episode
     */
    episode_of_care_id?: string;
    /**
     * 
     */
    actual_start_at: Date;
    /**
     * 
     */
    planned_end_at?: Date;
    /**
     * 
     */
    is_planned_end_confirmed?: boolean;
    /**
     * 
     */
    stay_type?: EncounterStayType;
    /**
     * 
     */
    comment?: string;
    /**
     * With episode_of_care_id. 409 if the episode changed since.
     */
    expected_latest_history_id?: string;
}



/**
 * Check if a given object implements the CreateInProgressEncounterRequest interface.
 */
export function instanceOfCreateInProgressEncounterRequest(value: object): value is CreateInProgressEncounterRequest {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('actual_start_at' in value) || value['actual_start_at'] === undefined) return false;
    return true;
}

export function CreateInProgressEncounterRequestFromJSON(json: any): CreateInProgressEncounterRequest {
    return CreateInProgressEncounterRequestFromJSONTyped(json, false);
}

export function CreateInProgressEncounterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInProgressEncounterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'episode_of_care_id': json['episode_of_care_id'] == null ? undefined : json['episode_of_care_id'],
        'actual_start_at': (json['actual_start_at'] == null ? json['actual_start_at'] : parseDateTime(json['actual_start_at'])),
        'planned_end_at': json['planned_end_at'] == null ? undefined : (parseDateTime(json['planned_end_at'])),
        'is_planned_end_confirmed': json['is_planned_end_confirmed'] == null ? undefined : json['is_planned_end_confirmed'],
        'stay_type': json['stay_type'] == null ? undefined : EncounterStayTypeFromJSON(json['stay_type']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'expected_latest_history_id': json['expected_latest_history_id'] == null ? undefined : json['expected_latest_history_id'],
    };
}

export function CreateInProgressEncounterRequestToJSON(json: any): CreateInProgressEncounterRequest {
    return CreateInProgressEncounterRequestToJSONTyped(json, false);
}

export function CreateInProgressEncounterRequestToJSONTyped(value?: CreateInProgressEncounterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'episode_of_care_id': value['episode_of_care_id'],
        'actual_start_at': value['actual_start_at'] == null ? value['actual_start_at'] : serializeDateTime(value['actual_start_at']),
        'planned_end_at': value['planned_end_at'] == null ? value['planned_end_at'] : serializeDateTime(value['planned_end_at']),
        'is_planned_end_confirmed': value['is_planned_end_confirmed'],
        'stay_type': EncounterStayTypeToJSON(value['stay_type']),
        'comment': value['comment'],
        'expected_latest_history_id': value['expected_latest_history_id'],
    };
}

